export default {
  schemas: [
    'goodSchema',
    'address',
    'email',
    'factor',
    'file',
    'phone',
    'caseHumanRelationship',
    'GroupHumanRelation',
    'HumanCaseRelation',
    'HumanGroupRelation',
    'humanRelationshipSchema',
    'template',
    'PhaseOrder',
    'taskForm',
    'taskFormAssignedTo',
    'TaskOrder',
    'TaskProgressReview',
    'TransactionInfo',
    'TransactionInfoSignature',
    'eventRepeatSetting',
    'eventRegistration',
    'eventBadge',
    'eventOrganization',
    'humanOrganizationRelationshipSchema',
    'HumanProgramRelation',
    'OrganizationHumanRelationSchema',
    'memo',
    'eventDay'
  ],
  prefix_sufix: [
    '_create',
    '_created',
    '_update',
    '_updated',
    '_response',
    '_collection'
  ],
  collections: [
    //'User',
    //'Human'
  ],
};



// WEBPACK FOOTER //
// ./src/helpers/mediator/hideCollections.js